import { apiClient } from "./client";
import type { Search, SearchCreateData, Listing } from "../types/index.js";

export const searchApi = {
  createSearch: async (data: SearchCreateData): Promise<Search> => {
    const response = await apiClient.post<Search>("/searches/", data);
    return response.data;
  },

  getSearches: async (): Promise<Search[]> => {
    const response = await apiClient.get<Search[]>("/searches/");
    return response.data;
  },

  getSearch: async (searchId: number): Promise<Search> => {
    const response = await apiClient.get<Search>(`/searches/${searchId}`);
    return response.data;
  },

  getListingsBySearch: async (searchId: number): Promise<Listing[]> => {
    const response = await apiClient.get<Listing[]>(
      `/listings/search/${searchId}`,
    );
    return response.data;
  },

  getListingDetail: async (listingId: number): Promise<Listing> => {
    const response = await apiClient.get<Listing>(`/listings/${listingId}`);
    return response.data;
  },

  exportListings: async (searchId: number): Promise<Blob> => {
    const response = await apiClient.get(
      `/listings/search/${searchId}/export`,
      {
        responseType: "blob",
      },
    );
    return response.data;
  },

  getDetailProgress: async (
    searchId: number,
  ): Promise<{
    detail_scrape_status: string | null;
    detail_scrape_progress: number;
    detail_scrape_total: number;
    detail_scrape_started_at: string | null;
    detail_scrape_completed_at: string | null;
  }> => {
    const response = await apiClient.get(
      `/searches/${searchId}/detail-progress`,
    );
    return response.data;
  },
};
